import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data() {
    return {
      loadingSubscriptions: []
    };
  },
  computed: {
    ...mapFields('subscription', {
      subscriptionIds: 'allIds',
      subscriptionsById: 'byId',
      subscriptionIdsCached: 'cacheAllIds'
    }),
    ...mapGetters('subscription', {
      findSubscription: 'find'
    })
  },
  methods: {
    ...mapActions('subscription', {
      retrieveSubscription: 'load',
      resetAllSubscriptionData: 'resetAllData'
    }),
    resolveSubscription(itemId) {
      if (!this.isSubscriptionLoaded(itemId) && !this.loadingSubscriptions.includes(itemId)) {
        this.loadingSubscriptions.push(itemId);
        this.retrieveSubscription(decodeURIComponent(itemId));
      }
      return this.findSubscription(itemId);
    },
    resolveSubscriptions(itemIds) {
      this.loadingSubscriptions = [];
      if (typeof itemIds === 'undefined') {
        return [];
      }
      return itemIds
        .map((itemId) => {
          return this.resolveSubscription(itemId);
        })
        .filter((e) => e);
    },
    getSubscriptionItem(subscriptionIri, type) {
      if (subscriptionIri !== null) {
        let subscription = this.resolveSubscription(subscriptionIri);
        if (subscription) {
          return subscription[type];
        }
      }
      return '';
    },
    isSubscriptionLoaded(itemId) {
      return this.subscriptionIdsCached.includes(itemId);
    },
    isSubscriptionSetLoaded(itemIds) {
      return itemIds.every((itemId) => this.isSubscriptionLoaded(itemId));
    },
    resolveSubscriptionAsync(itemId) {
      const poll = (resolve) => {
        if (this.isSubscriptionLoaded(itemId)) {
          resolve(this.resolveSubscription(itemId));
        } else {
          this.resolveSubscription(itemId);
          setTimeout(() => poll(resolve), 400);
        }
      };
      return new Promise(poll);
    },
    resolveSubscriptionsAsync(itemIds) {
      const poll = (resolve) => {
        if (this.isSubscriptionSetLoaded(itemIds)) {
          resolve(this.resolveSubscriptions(itemIds));
        } else {
          this.resolveSubscriptions(itemIds);
          setTimeout(() => poll(resolve), 400);
        }
      };
      return new Promise(poll);
    },
    clearSubscriptionData() {
      this.loadingSubscriptions = [];
      this.resetAllSubscriptionData();
    },
    resolveSubscriptionChildren(currentSubscription, children) {
      let childSubscriptions = [];
      currentSubscription.children.forEach((childSubscription) => {
        const child = children.find((ct) => ct['@id'] === childSubscription);
        if (child) {
          childSubscriptions.push({ id: childSubscription, title: child['title'] });
        }
      });

      return {
        id: currentSubscription['@id'],
        title: currentSubscription['title'],
        ...(childSubscriptions.length > 0 ? { children: childSubscriptions } : {})
      };
    },
    subscriptionNodeNormalizer(node) {
      return {
        label: node['title'],
        children: node.children
      };
    }
  }
};
